//DEV
export const BASE_URL = "https://apidev.technixia.com/api";

//LOCAL
// export const BASE_URL = "http://localhost:9001/api"
